export default "__VITE_ASSET__D_bZ93Gw__"